// extracted by mini-css-extract-plugin
export default {"root":"GetYourGuideWidget_root__LGEs7","widget":"GetYourGuideWidget_widget__WsELv"};